import React from 'react'
import Sound from "react-sound"
import clsx from 'clsx'
import {
    MdFastForward,
    MdFastRewind,
    MdPlayArrow,
    MdPause
} from "react-icons/md"

const playerControls = ({
    player,
    playTrack,
    pauseTrack,
    setEpisode,
    classes
}) => {

    const getCurrentTrackPosition = () => player.playlist.findIndex(episode => episode.id === player.episode.id)

    const prevTrackHandler = () => {
        const currentTrackPosition = getCurrentTrackPosition()
        if (currentTrackPosition > 0) {
            const prevTrack = player.playlist[currentTrackPosition - 1]
            setEpisode(prevTrack)
        }
    }

    const nextTrackHandler = () => {
        const currentTrackPosition = getCurrentTrackPosition()
        if (currentTrackPosition < (player.playlist.length - 1)) {
            const nextTrack = player.playlist[currentTrackPosition + 1]
            setEpisode(nextTrack)
        }
    }

    return (
        <div className={clsx(
            "player-controls", {
            [classes]: !!classes
        }
        )}>
            <button
                className={
                    clsx("player-prev-button", {
                        "player-control-inactive": getCurrentTrackPosition() === 0,
                    })
                }
                onClick={prevTrackHandler}
            >
                <MdFastRewind size="2rem" />
            </button>
            {!!player.episode.content && player.statusSong === Sound.status.PLAYING ? (
                <button
                    className="player-play-button"
                    onClick={() => pauseTrack()}
                >
                    <MdPause size="3rem" />
                </button>
            ) : (
                    <button
                        className="player-play-button"
                        onClick={() => playTrack()}
                    >
                        <MdPlayArrow size="3rem" />
                    </button>
                )}
            <button
                className={
                    clsx("player-next-button", {
                        "player-control-inactive": getCurrentTrackPosition() === (player.playlist.length - 1),
                    })
                }
                onClick={nextTrackHandler}
            >
                <MdFastForward size="2rem" />
            </button>
        </div>
    )
}

export default playerControls
